import * as Phaser from "phaser";
import { scenes } from "$/keys";

type OverlayValue<T> = T extends string ? T
  : T extends Record<string, unknown> ? OverlayValue<T[keyof T]>
  : never;

type OverlayKey = OverlayValue<typeof scenes.overlays>;

export class OverlayScenePlugin extends Phaser.Plugins.ScenePlugin {
  constructor(
    scene: Phaser.Scene,
    pluginManager: Phaser.Plugins.PluginManager,
    key: string = "overlay",
  ) {
    super(scene, pluginManager, key);
  }

  public show(
    overlayName: OverlayKey,
    showCloseButton: boolean = true,
    data: Record<string, any> = {},
  ) {
    this.scene?.scene.pause();
    this.scene?.scene.launch(overlayName, {
      fromScene: this.scene?.scene.key,
      showCloseButton: showCloseButton,
      ...data,
    });
    this.scene?.scene.bringToTop(overlayName);
  }

  public close(overlayName: OverlayKey) {
    this.scene?.scene.stop(overlayName);
    this.scene?.scene.resume(this.scene?.scene.key);
  }
}
